import { render, staticRenderFns } from "./TabelaPreco.vue?vue&type=template&id=3a41bdea&scoped=true"
import script from "./TabelaPreco.vue?vue&type=script&lang=js"
export * from "./TabelaPreco.vue?vue&type=script&lang=js"
import style0 from "./TabelaPreco.vue?vue&type=style&index=0&id=3a41bdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41bdea",
  null
  
)

export default component.exports